module.exports = __webpack_public_path__ + "img/merci_hubert.31960315.png";